export default {
  hour: 'ساعت',
  minutes: 'دقیقه',
  kilometer: 'کیلومتر',
  meter: 'متر',
  tons: 'تُن',
  kilogerams: 'کیلو گرم',
  grams: 'گرم'
}
